import { styled, Box, Button, Dialog } from "@mui/material";
import { brighthiveTheme } from "../../theme/theme";

export const ButtonHolder = styled(Box)`
  padding: 20px;
  justify-content: end;
  display: flex;
  gap: 20px;
  button.red {
    color: ${brighthiveTheme.palette.error.main};
  }
`;
export const ButtonPrimary = styled(Button)`
  background-color: ${brighthiveTheme.palette.primary.main};
  color: ${brighthiveTheme.palette.primary.darkest};
  border: 1px solid transparent;
  border-radius: 3px;
  box-shadow: none;
  min-width: 1px;

  &:hover {
    background-color: ${brighthiveTheme.palette.primary.dark};
    color: ${brighthiveTheme.palette.common.white};
    border-color: transparent;
    box-shadow: none;
  }
`;
export const ButtonOutline = styled(Button)`
  background-color: ${brighthiveTheme.palette.primary.main};
  color: ${brighthiveTheme.palette.primary.darkest};
  border: 1px solid transparent;
  border-radius: 3px;
  box-shadow: none;
  min-width: 1px;

  &:hover {
    background-color: ${brighthiveTheme.palette.primary.dark};
    color: ${brighthiveTheme.palette.common.white};
    border-color: transparent;
    box-shadow: none;
  }
`;
export const DialogCustom = styled(Dialog)`
  .slick-dots {
    bottom: -35px;
    li {
      &:hover,
      &.slick-active {
        button {
          background: ${brighthiveTheme.palette.primary.dark};
          &:before {
            color: ${brighthiveTheme.palette.common.white};
          }
        }
      }
      button {
        border: 1px solid ${brighthiveTheme.palette.primary.dark};
        background: ${brighthiveTheme.palette.primary.active};
        border-radius: 50%;
        padding: 0;
        &:before {
          color: ${brighthiveTheme.palette.primary.dark};
          display: block;
          text-align: center;
          position: static;
          opacity: 1;
          width: auto;
        }
      }
    }
  }
  .slick-prev,
  .slick-next {
    width: 60px;
    background: ${brighthiveTheme.palette.common.white};
    color: red;
    top: 0;
    bottom: 8px;
    height: auto;
    transform: none;
    z-index: 9;
    opacity: 0;
    transition: all 0.3s ease;

    &:before {
      width: 14px;
      height: 14px;
      display: block;
      margin: 0 auto;
      border: 2px solid ${brighthiveTheme.palette.primary.dark};
      border-width: 4px 4px 0 0;
      transform: rotate(45deg);
      content: "";
      transition: all 0.3s ease;
    }
    &:focus,
    &:hover {
      background: ${brighthiveTheme.palette.common.white};
    }
    &:before {
      opacity: 1;
      transition: all 0.3s ease;
    }
  }
  .slick-prev {
    left: 0;
    transition: all 0.3s ease;
    &:before {
      transform: rotate(-135deg);
    }
  }
  .slick-next {
    right: 0;
    transition: all 0.3s ease;
  }
  .slick-slider {
    &:hover {
      .slick-prev,
      .slick-next {
        opacity: 0.8;
      }
    }
    .slick-list {
      overflow: visible;
    }
    .slick-slide {
      position: relative;
      button.red {
        position: absolute;
        bottom: -62px;
        left: 20px;
        color: ${brighthiveTheme.palette.error.main};
      }
    }
  }
`;
